import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_PLAYER_DETAILS = Symbol('admin-players.profile');
export const ADMIN_PLAYER_PROFILE_ROUTE_NAME = Symbol('admin.players.additional.profile');
export const PLAYER_TRACKING_HISTORY_EDIT_ROUTE_NAME = Symbol('admin.players.additional.profile.tracker-history-edit');
export const PLAYER_PROFILE_QUERY_KEY = 'player-profile';
export const PLAYER_TRACKING_HISTORY_QUERY_KEY = 'player-profile-tracking';

export const PLAYER_PROFILE_API_URL = 'admin/observing_of_daily_statistics_players/:playerId';

export const PLAYER_PROFILE_TRACKING_API_URL = 'admin/observing_of_daily_statistics_players/:playerId/trackers';

// Histories

export const PLAYER_HISTORY_API_URL = 'admin/observing_of_daily_statistics_players/:playerId/history_of_players_changes/:historyId/edit';
export const PLAYER_HISTORY_QUERY_KEY = 'history-show';

export const CREATE_PLAYER_HISTORY_QUERY_URL = 'admin/observing_of_daily_statistics_players/:playerId/history_of_players_changes';
export const CREATE_PLAYER_HISTORY_MUTATION_KEY = 'history-update';

export const REMOVE_PLAYER_HISTORY_QUERY_URL = 'admin/observing_of_daily_statistics_players/:playerId/history_of_players_changes/:historyId';
export const REMOVE_PLAYER_HISTORY_MUTATION_KEY = 'history-remove';

export const EDIT_PLAYER_HISTORY_QUERY_URL = 'admin/observing_of_daily_statistics_players/:playerId/history_of_players_changes/:historyId';
export const EDIT_PLAYER_HISTORY_MUTATION_KEY = 'history-edit';

export const PLAYER_PROFILE_PERMISSIONS = {
  PLAYERS_TRACKING: new Permission(
    PermissionsList.admin.OBSERVINGOFDAILYSTATISTICSPLAYERS_TRACKERS,
  ),
};
